// removed by extract-text-webpack-plugin
module.exports = {"imageWrapper":"src-components-project-project-print-ads----project-print-ads-module---imageWrapper---gayUZ","page":"src-components-project-project-print-ads----project-print-ads-module---page---36EX-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-print-ads/project-print-ads.module.css
// module id = 530
// module chunks = 140935043865547